import React, { useState } from 'react'
import "./Gallery.css"
import { openInstagram } from '../../app/utils/links'
import img1 from "../../app/assets/images/gallery/gallery-1.webp";
import img2 from "../../app/assets/images/gallery/gallery-2.webp";
import img3 from "../../app/assets/images/gallery/gallery-3.jpeg";
import img4 from "../../app/assets/images/gallery/gallery-4.webp";
import img5 from "../../app/assets/images/gallery/gallery-5.webp";
// import img6 from "../../app/assets/images/gallery/gallery-6.webp";
// import img7 from "../../app/assets/images/gallery/gallery-7.webp";
import img8 from "../../app/assets/images/gallery/gallery-8.webp";
// import img9 from "../../app/assets/images/gallery/gallery-9.webp";
// import img10 from "../../app/assets/images/gallery/gallery-10.webp";
import img11 from "../../app/assets/images/gallery/gallery-11.webp";
// import img12 from "../../app/assets/images/gallery/gallery-12.webp";
// import img13 from "../../app/assets/images/gallery/gallery-13.webp";
import img14 from "../../app/assets/images/gallery/gallery-14.webp";
import img15 from "../../app/assets/images/gallery/gallery-15.webp";
import img16 from "../../app/assets/images/gallery/gallery-16.webp";
import img17 from "../../app/assets/images/gallery/gallery-17.webp";
// import img18 from "../../app/assets/images/gallery/gallery-18.webp";
// import img19 from "../../app/assets/images/gallery/gallery-19.webp";
import img20 from "../../app/assets/images/gallery/gallery-20.webp";
import img21 from "../../app/assets/images/gallery/gallery-21.webp";
// import img22 from "../../app/assets/images/gallery/gallery-22.webp";
// import img23 from "../../app/assets/images/gallery/gallery-23.webp";
// import img24 from "../../app/assets/images/gallery/gallery-24.webp";
// import img25 from "../../app/assets/images/gallery/gallery-25.webp";
import img26 from "../../app/assets/images/gallery/gallery-26.jpeg";
// import img27 from "../../app/assets/images/gallery/gallery-27.webp";
import img28 from "../../app/assets/images/gallery/gallery-28.webp";
import img29 from "../../app/assets/images/gallery/gallery-29.webp";
import img30 from "../../app/assets/images/gallery/gallery-30.webp";
// import img31 from "../../app/assets/images/gallery/gallery-31.webp";
import img32 from "../../app/assets/images/gallery/gallery-32.webp";
import img33 from "../../app/assets/images/gallery/gallery-33.webp";
import img34 from "../../app/assets/images/gallery/gallery-34.webp";
// import img35 from "../../app/assets/images/gallery/gallery-35.webp";
// import img36 from "../../app/assets/images/gallery/gallery-36.webp";
// import img37 from "../../app/assets/images/gallery/gallery-37.webp";
// import img38 from "../../app/assets/images/gallery/gallery-38.webp";
// import img39 from "../../app/assets/images/gallery/gallery-39.webp";
import img40 from "../../app/assets/images/gallery/gallery-40.jpeg";
import img41 from "../../app/assets/images/gallery/gallery-41.jpeg";
import img42 from "../../app/assets/images/gallery/gallery-42.webp";
// import img43 from "../../app/assets/images/gallery/gallery-43.jpeg";
// import img44 from "../../app/assets/images/gallery/gallery-44.jpeg";
import img45 from "../../app/assets/images/gallery/gallery-45.jpeg";
import img46 from "../../app/assets/images/gallery/gallery-46.jpeg";
// import img47 from "../../app/assets/images/gallery/gallery-47.jpeg";
// import img48 from "../../app/assets/images/gallery/gallery-48.jpeg";
// import img49 from "../../app/assets/images/gallery/gallery-49.jpeg";
import img50 from "../../app/assets/images/gallery/gallery-50.jpeg";
// import img51 from "../../app/assets/images/gallery/gallery-51.jpeg";
import img52 from "../../app/assets/images/gallery/gallery-52.webp";
// import img53 from "../../app/assets/images/gallery/gallery-53.webp";
import img54 from "../../app/assets/images/gallery/gallery-54.jpeg";
import img55 from "../../app/assets/images/gallery/gallery-55.jpeg";
// import img56 from "../../app/assets/images/gallery/gallery-56.webp";
import img57 from "../../app/assets/images/gallery/gallery-57.webp";
import img58 from "../../app/assets/images/gallery/gallery-58.webp";
import img59 from "../../app/assets/images/gallery/gallery-59.webp";
import img60 from "../../app/assets/images/gallery/gallery-60.webp";
import img61 from "../../app/assets/images/gallery/gallery-61.webp";
import img62 from "../../app/assets/images/gallery/gallery-62.webp";
import img63 from "../../app/assets/images/gallery/gallery-63.webp";
// import img64 from "../../app/assets/images/gallery/gallery-64.webp";
import img66 from "../../app/assets/images/gallery/gallery-66.webp";
// import img67 from "../../app/assets/images/gallery/gallery-67.webp";


  // Sample Data
 const galleryItems = [
  { id: 1, img: img1 },
  { id: 2, img: img2 },
  { id: 3, img: img3 },
  { id: 4, img: img4 },
  { id: 5, img: img5 },
  // { id: 6, img: img6 },
  // { id: 7, img: img7 },
  { id: 8, img: img8 },
  // { id: 9, img: img9 },
//   { id: 10, img: img10 },
  { id: 11, img: img11 },
  // { id: 12, img: img12 },
  // { id: 13, img: img13 },
  { id: 14, img: img14 },
  { id: 15, img: img15 },
  { id: 16, img: img16 },
  { id: 17, img: img17 },
  // { id: 18, img: img18 },
  // { id: 19, img: img19 },
  { id: 20, img: img20 },
  { id: 21, img: img21 },
//   { id: 22, img: img22 },
  // { id: 23, img: img23 },
  // { id: 24, img: img24 },
  // { id: 25, img: img25 },
  { id: 26, img: img26 },
  // { id: 27, img: img27 },
  { id: 28, img: img28 },
  { id: 29, img: img29 },
  { id: 30, img: img30 },
  // { id: 31, img: img31 },
  { id: 32, img: img32 },
  { id: 33, img: img33 },
  { id: 34, img: img34 },
  // { id: 35, img: img35 },
  // { id: 36, img: img36 },
  // { id: 37, img: img37 },
  // { id: 38, img: img38 },
  // { id: 39, img: img39 },
  { id: 40, img: img40 },
  { id: 41, img: img41 },
  { id: 42, img: img42 },
  // { id: 43, img: img43 },
  // { id: 44, img: img44 },
  { id: 45, img: img45 },
  { id: 46, img: img46 },
  // { id: 47, img: img47 },
  // { id: 48, img: img48 },
  // { id: 49, img: img49 },
  { id: 50, img: img50 },
  // { id: 51, img: img51 },
  { id: 52, img: img52 },
  // { id: 53, img: img53 },
  { id: 54, img: img54 },
  { id: 55, img: img55 },
  // { id: 56, img: img56 },
  { id: 57, img: img57 },
  { id: 58, img: img58 },
  { id: 59, img: img59 },
  { id: 60, img: img60 },
  { id: 61, img: img61 },
  { id: 62, img: img62 },
  { id: 63, img: img63 },
  // { id: 64, img: img64 },
  { id: 66, img: img66 },
//   { id: 67, img: img67 },
];


// Experiences Images
const experienceItems = [
   {
        id: 1,
        img: require("../../app/assets/images/look-closer.webp"),
    },

    {
        id: 2,
        img: require("../../app/assets/images/experience-img.jpeg"),
    },

    {
        id: 3,
        img: require("../../app/assets/images/stay-rooted.webp"),
    },

    {
        id: 4,
        img: require("../../app/assets/images/experience-img-3.webp"),
    },
       {
        id: 5,
        img: require("../../app/assets/images/experience-img-2.webp"),
    },

    {
        id: 6,
        img: require("../../app/assets/images/experience-img-4.webp"),
    },

    {
        id: 7,
        img: require("../../app/assets/images/gallery/gallery-78.webp"),
    },

    {
        id: 8,
        img: require("../../app/assets/images/gallery/gallery-79.webp"),
    },

    {
        id: 9,
        img: require("../../app/assets/images/gallery/gallery-80.webp"),
    },

    {
        id: 10,
        img: require("../../app/assets/images/gallery/gallery-81.webp"),
    },

    {
        id: 11,
        img: require("../../app/assets/images/gallery/gallery-22.webp"),
    },

    {
        id: 12,
        img: require("../../app/assets/images/build-coumnity-imgs.webp"),
    },

    {
        id: 13,
        img: require("../../app/assets/images/experience-img-5.webp"),
    },

    {
        id: 14,
        img: require("../../app/assets/images/experience-img-6.webp"),
    },

    {
        id: 15,
        img: require("../../app/assets/images/experience-img-7.webp"),
    },
];

// Learning Images
const learningItems = [
  {
        id: 1,
        img: require("../../app/assets/images/gallery/gallery-31.webp"),
    },

    {
        id: 2,
        img: require("../../app/assets/images/learning-img-2.jpg"),
    },
    {
        id: 3,
        img: require("../../app/assets/images/village-life.webp"),
    },
    {
        id: 4,
        img: require("../../app/assets/images/learning-img-3.jpeg"),
    },
    {
        id: 5,
        img: require("../../app/assets/images/learning-img.webp"),
    },
    {
        id: 6,
        img: require("../../app/assets/images/gallery/gallery-18.webp")
    },
    {
        id: 7,
        img: require("../../app/assets/images/gallery/gallery-23.webp")
    },
    {
        id: 8,
        img: require("../../app/assets/images/gallery/gallery-37.webp")
    },
       {
        id: 9,
        img: require("../../app/assets/images/gallery/gallery-38.webp")
    },
     {
        id: 10,
        img: require("../../app/assets/images/learning-imgs.webp")
    },
    {
        id: 11,
        img: require("../../app/assets/images/build-coumnity-img.webp")
    },
];

// Community Images
const communityItems = [
  {
        id: 1,
        img: require("../../app/assets/images/build-community.webp"),
    },
    // {
    //     id: 2,
    //     img: require("../../app/assets/images/build-coumnity-imgs.webp"),
    // },
    // {
    //     id: 3,
    //     img: require("../../app/assets/images/build-coumnity-img.webp"),
    // },
    // {
    //     id: 4,
    //     img: require("../../app/assets/images/community-img.jpeg"),
    // },
    {
        id: 4,
        img: require("../../app/assets/images/gallery/gallery-68.webp"),
    },
    {
        id: 5,
        img: require("../../app/assets/images/gallery/gallery-69.webp"),
    },
    {
        id: 6,
        img: require("../../app/assets/images/gallery/gallery-70.webp"),
    },
    {
        id: 7,
        img: require("../../app/assets/images/gallery/gallery-71.webp"),
    },
    {
        id: 8,
        img: require("../../app/assets/images/gallery/gallery-72.webp"),
    },
    {
        id: 9,
        img: require("../../app/assets/images/gallery/gallery-73.webp"),
    },
    {
        id: 10,
        img: require("../../app/assets/images/gallery/gallery-74.webp"),
    },
    {
        id: 11,
        img: require("../../app/assets/images/gallery/gallery-75.webp"),
    },
    {
        id: 12,
        img: require("../../app/assets/images/gallery/gallery-76.webp"),
    },
    {
        id: 13,
        img: require("../../app/assets/images/gallery/gallery-77.webp"),
    },
];


// const gallery = [
//     {
//         id: 1,
//         img: require("../../app/assets/images/stone-cottage.webp"),
//         category: "Stay",
//     },
//     {
//         id: 2,
//         img: require("../../app/assets/images/8.webp"),
//         category: "Stay",
//     },
//     {
//         id: 3,
//         img: require("../../app/assets/images/9.webp"),
//         category: "Stay",
//     },
//     {
//         id: 4,
//         img: require("../../app/assets/images/12.webp"),
//         category: "Stay",
//     },

//     {
//         id: 5,
//         img: require("../../app/assets/images/look-closer.webp"),
//         category: "Experiences",
//     },

//     {
//         id: 6,
//         img: require("../../app/assets/images/experience-img.jpeg"),
//         category: "Experiences",
//     },

//     {
//         id: 7,
//         img: require("../../app/assets/images/stay-rooted.webp"),
//         category: "Experiences",
//     },

//     {
//         id: 8,
//         img: require("../../app/assets/images/experience-img-3.webp"),
//         category: "Experiences",
//     },

//     {
//         id: 9,
//         img: require("../../app/assets/images/school-group.webp"),
//         category: "Learning",
//     },

//     {
//         id: 10,
//         img: require("../../app/assets/images/learning-img-2.webp"),
//         category: "Learning",
//     },
//     {
//         id: 11,
//         img: require("../../app/assets/images/village-life.webp"),
//         category: "Learning",
//     },
//     {
//         id: 12,
//         img: require("../../app/assets/images/learning-img-3.jpeg"),
//         category: "Learning",
//     },
//     {
//         id: 13,
//         img: require("../../app/assets/images/build-community.webp"),
//         category: "Community",
//     },
//     {
//         id: 14,
//         img: require("../../app/assets/images/build-coumnity-imgs.webp"),
//         category: "Community",
//     },
//     {
//         id: 15,
//         img: require("../../app/assets/images/build-coumnity-img.webp"),
//         category: "Community",
//     },
//     {
//         id: 16,
//         img: require("../../app/assets/images/community-img.jpeg"),
//         category: "Community",
//     },
//     {
//         id: 17,
//         img: require("../../app/assets/images/learning-img.webp"),
//         category: "Learning",
//     },

//     {
//         id: 18,
//         img: require("../../app/assets/images/experience-img-2.webp"),
//         category: "Experiences",
//     },

//     {
//         id: 19,
//         img: require("../../app/assets/images/experience-img-4.webp"),
//         category: "Experiences",
//     },

//     {
//         id: 19,
//         img: require("../../app/assets/images/17.webp"),
//         category: "Stay",
//     },
// ]

const galleryData = {
  Property: galleryItems,
  Experiences: experienceItems,
  Learning: learningItems,
  Community: communityItems,
};

function Gallery() {
    const [filter, setFilter] = useState('all');

    const [activeTab, setActiveTab] = useState("Property");
    
        // const galleryData = {
        //     Experiences: gallery.filter((item) => item.category === "Experiences"),
        //     Stay: gallery.filter((item) => item.category === "Stay"),
        //     Learning: gallery.filter((item) => item.category === "Learning"),
        //     Community: gallery.filter((item) => item.category === "Community"),
        // };




  return (
    <>
     <div className="gallery-wrapper">
      {/* Banner Section */}
      <section className="banner_sec banner-padding gallery-banner">
        <div className="container text-center">
          <div className="banner-wraper">
            <h1 className="banner-heading">Our Visual <span>Journey</span></h1>
            <p className="banner-sub-heading">Capturing moments of change and the beauty of Kumaon.</p>
            <div className="diveder-bx2"></div>
          </div>
        </div>
      </section>

      {/* Filter & Gallery Section */}
      <section className="section-padding bg-color">
        <div className="container">
          
          <div className="heading-content-wraper text-center">
            <span className="top-heading">MOMENTS CAPTURED</span>
            <h2 className="heading">Explore our <span>Gallery</span></h2>
            <div className="diveder-bx"></div>
          </div>

          {/* Filter Buttons */}
          {/* <div className="d-flex justify-content-center flex-wrap gap-3 mb-5">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setFilter(cat)}
                className={filter === cat ? 'primary_btn text-capitalize' : 'outline_btn text-capitalize'}
                style={{ minWidth: '120px' }}
              >
                {cat}
              </button>
            ))}
          </div> */}

          <nav className="gallery-nav  mb-4 mt-md-0 d-flex gap-3 flex-wrap">
                        {["Property", "Experiences", "Learning", "Community"].map((tab) => (
                            <a
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={activeTab === tab ? "active" : ""}
                                style={{ cursor: "pointer" }}
                            >
                                {tab}
                            </a>
                        ))}
                    </nav>

          {/* Image Grid */}
          <div className="row g-4">
            {galleryData[activeTab].map((item) => (
              <div className="col-md-6 col-lg-4" key={item.id}>
                <div className="info-card gallery-card bg-white h-100 shadow-sm">
                  <div className="gallery-img-container overflow-hidden">
                    <img loading="lazy" decoding="async" 
                        src={item.img} 
                        alt={item.title} 
                        className="gallery-hover-effect"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center mt-5 py-4">
              <p className="content mb-4">Want to see more of our impact?</p>
              <button className="primary_btn px-5" onClick={openInstagram}>Follow us on Instagram</button>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default Gallery